import { render, staticRenderFns } from "./CompDB.vue?vue&type=template&id=85de4de2&"
import script from "./CompDB.vue?vue&type=script&lang=js&"
export * from "./CompDB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports